export const colors = {
  background: {
    white: '#ffffff',
    primaryBlack: '#1B1C1F',
    primaryTab: '#CCE6E6',
    inputBox: '#F7F7F7',
    primaryBackground: '#F5F5F5',
    secondaryBackground: '#FBFBFD',
    primaryGray: '#CECECE',
    lightCyan: '#D4FFFF',
    approxWhiteSmoke: '#F6F6F6',
    approxAliceBlue: '#F7F9FA',
    cardBackground: '#ffffff',
    feedBackground: '#F9FAFB',
    imageDefaultBackground: '#5D6E6E',
    clearButtoncolor: '#FFEBEB',
    adminPinned: 'rgba(104,189,189,0.6)',
    maxPollGreen: 'rgba(0,141,141,1)',
    myPollGreen: 'rgba(104,189,189,1)',
    pollGray: 'rgba(146,146,146,1)',
    pollChoice: 'rgb(214, 214, 214)',
    pollChoicewhite: 'rgb(255, 255, 255)',
    repostThoughtBg: '#EEFFFF',
    topicTagBg: '#FFF0EF'
  },
  text: {
    primaryBlack: '#1C1B1F',
    secondaryBlack: '#393939',
    tertiaryBlack: '#2F2924',
    quaternaryBlack: '#232323',
    primaryBlue: '#9E52FF',
    primaryOrange: '#F6863A',
    primaryTheme: 'rgb(2, 131, 131)',
    primaryThemeShade: '#d0eaf0',
    secondaryTheme: '#1EA1B2',
    primaryGray: '#F2F2F2',
    secondaryGray: 'rgba(101, 93, 83, 0.60)',
    primaryWhite: '#ffffff',
    brightBlue: '#1D7791',
    darkBlack: '#000000',
    darkGray: '#616161',
    grey: '#DADADA',
    blackGray: '#303030',
    lightShadeGray: '#EBFFFF',
    approxIvory: '#F8FFFF',
    titanWhite: '#d5d4d9',
    approxWhiteSmoke: '#F4F4F4',
    approxGainsboro: '#d9d9d9',
    approxGainGray: '#E1E1E1',
    lightShade: '#DDDDDD',
    approxLightShade: '#EFEFEF',
    approxSuvaGrey: '#898989',
    approxNero: '#282828',
    approxVeryLightGrey: '#C8C8C8',
    approxAliceBlue: '#EFFCFC',
    deleteComment: ' #9F9F9F',
    clearButton: ' #6B6B6B',
    pollQuestion: 'rgba(48, 48, 48, 1)',
    pollPercentage: ' #212121',
    pollCount: 'rgba(29, 119, 145, 1)',
    defaultCheckbox: 'rgba(29, 27, 32, 1)',
    pollInputColor: 'rgba(28, 27, 31, 1)',
    moreLinkColor: '#008080',
    richTextLink: '#007575',
    designationColor: '#6A7282',
    dateColor: '#6A7282',
    descriptionColor: '#364153',
    iconFillGray: '#99A1AF'
  },
  shadow: {
    primary: '#B8B8B8'
  },
  border: {
    secondaryGray: '#A1A1A1',
    tertiaryTheme: '#1EA2AF',
    primary: '#F0F0F0',
    pollGray: 'rgba(146,146,146, 1)',
    pollGreen: 'rgba(0,141,141, 1)',
    pollBeforeTakingPoll: 'rgba(199, 199, 199, 1)',
    defaultPoll: 'rgb(240, 240, 240)',
    myVotedpoll: 'rgba(104, 189, 189,0.8)'
  },
  borderColor: {
    primaryDust: '#A1A1A1'
  },
  error: {
    primaryRed: '#FF0000'
  },
  placeHolder: {
    input: '#89888A'
  },
  linkBlue: '#279FBA'
};
